import { isBefore } from '@eversports/dates'

import { EventDifficultyLevel } from '../../../../../App.types'
import { ActivityLocationType } from '../components/Filters/Filters.types'

function formatUrlParam<T>(urlParam: URLParam) {
  if (!urlParam) return
  return (Array.isArray(urlParam) ? urlParam : [urlParam]) as Array<T>
}

type URLParam = string | Array<string> | undefined | null

interface Props {
  dateParam?: URLParam
  timeParam?: URLParam
  activityLocationParam?: URLParam
  levelParam?: URLParam
}

// TODO - will discuss with the frontend group option for schema/params validation
export default function formatQueryParams({ dateParam, timeParam, activityLocationParam, levelParam }: Props) {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  // DATE
  const dateStr = Array.isArray(dateParam) ? dateParam[0] : dateParam
  const isValidDate = dateStr && !isNaN(Date.parse(dateStr))
  const parsedDate = isValidDate ? new Date(dateStr) : new Date()
  const boundedDate = isBefore(parsedDate, today) ? today : parsedDate

  // TIME
  const timeStr = Array.isArray(timeParam) ? timeParam[0] : timeParam
  // TODO - again need a better validation method - while this catches 900 as 9:00, and 1300 as 13:00, it also catches 9000 - which would be 90 hours into the future
  const isValidTime = timeStr && /^\d{3,4}$/.test(timeStr)
  const startHour = isValidTime ? Math.floor(parseInt(timeStr) / 100) : 0

  if (isValidTime) {
    boundedDate.setHours(startHour)
  }

  // Ensure we are at top of the hour
  boundedDate.setMinutes(0, 0, 0)

  // ACTIVITY LOCATION
  const activityLocationType = formatUrlParam<ActivityLocationType>(activityLocationParam)

  // LEVEL
  const difficultyLevel = formatUrlParam<EventDifficultyLevel>(levelParam)

  return {
    timeRange: { start: boundedDate.toISOString() },
    ...(activityLocationType?.length && { activityLocationType }),
    ...(difficultyLevel?.length && { difficultyLevel }),
  }
}
